import { ConsignmentTabFields } from '../types/fieldEnums';
import { type TValidationConfig } from '../types/configs';

import { getObjectValidation, getStringValidation } from './validations';

function getConsignmentSchema(validationConfig: TValidationConfig) {
  return {
    [ConsignmentTabFields.transitCountryCode]: getObjectValidation({ field: ConsignmentTabFields.transitCountryCode }),
    [ConsignmentTabFields.firstPointOfArrival]: getStringValidation({
      field: ConsignmentTabFields.firstPointOfArrival,
      validationConfig,
    }),
    [ConsignmentTabFields.meanOfTransportCode]: getObjectValidation({
      field: ConsignmentTabFields.meanOfTransportCode,
    }),
    [ConsignmentTabFields.transportMeansOfIdentity]: getStringValidation({
      field: ConsignmentTabFields.transportMeansOfIdentity,
      validationConfig,
    }),
    [ConsignmentTabFields.voyageNumber]: getStringValidation({
      field: ConsignmentTabFields.voyageNumber,
      validationConfig,
    }),
  };
}

export default getConsignmentSchema;
